module.exports = __webpack_public_path__ + "img/shopping-bag.e5b84669.svg";